import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import {
  Opts,
  QueryParams,
  PagedResponse,
  Model,
} from "@ofqual/portal-core/core/types";
import { paramsToSearchString } from "@ofqual/portal-core/core/utils/urlHelper";

export interface LegacyPagedResponse<T> {
  data: T[];
  totalCount: number;
  page: number;
  pageSize: number;
}

export class AwardingOrgSearchService extends BaseRemoteService {
  public async search(
    params: QueryParams = {},
    opts: Opts
  ): Promise<PagedResponse<Model>> {
    const url = `${this.apiRoot}/organisations${paramsToSearchString(params)}`;
    const response = await super.getRequest<
      LegacyPagedResponse<Model>
    >(url, opts);
    const mappedData = response.data.map((item) => ({
      id: item.itemId,
      label: item.name,
    }));
    return {
      ...response,
      data: mappedData,
      count: response.totalCount,
    };
  }
}
